import api from "./client";
import { logger } from "@/utils/logger";
const gtfsApi = {
    buildGtfs(payload) {
        const fd = new FormData();
        fd.append("agency_name", payload.agency_name);
        fd.append("agency_url", payload.agency_url);
        fd.append("agency_timezone", payload.agency_timezone);
        fd.append("start_date", payload.start_date);
        fd.append("end_date", payload.end_date);
        if (payload.route_type != null) {
            fd.append("route_type", String(payload.route_type));
        }
        if (payload.dwell_seconds != null) {
            fd.append("dwell_seconds", String(payload.dwell_seconds));
        }
        if (payload.files?.duraklar)
            fd.append("duraklar", payload.files.duraklar);
        if (payload.files?.hat_durak)
            fd.append("hat_durak", payload.files.hat_durak);
        if (payload.files?.servis)
            fd.append("servis", payload.files.servis);
        return api
            .post("/gtfs/build", fd, {
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((res) => res.data);
    },
    buildGtfsFromJson(payload) {
        return api.post("/gtfs/build-from-json", payload).then((res) => res.data);
    },
    validateGtfsCsvs(files) {
        const fd = new FormData();
        if (files.stops)
            fd.append("stops", files.stops);
        if (files.route_stops)
            fd.append("route_stops", files.route_stops);
        if (files.services)
            fd.append("services", files.services);
        return api
            .post("/gtfs/validate-csvs", fd, {
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((res) => res.data);
    },
    inspectGtfs(file, opts) {
        const fd = new FormData();
        fd.append("gtfs", file);
        if (opts?.lite)
            fd.append("lite", "1");
        logger.debug("API'ye gönderilen dosya:", file);
        return api
            .post("/gtfs/inspect", fd, {
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((res) => {
            logger.debug("API yanıtı:", res);
            logger.debug("API yanıt data:", res.data);
            let parsedData = res.data;
            if (typeof res.data === "string") {
                try {
                    parsedData = JSON.parse(res.data);
                    logger.debug("Parse edilen data:", parsedData);
                }
                catch (parseError) {
                    logger.error("JSON parse hatası:", parseError);
                    throw new Error("Backend yanıtı parse edilemedi");
                }
            }
            return parsedData;
        })
            .catch((error) => {
            logger.error("API hatası:", error);
            const axiosError = error;
            logger.error("API hata detayları:", {
                message: axiosError.message,
                status: axiosError.response?.status,
                data: axiosError.response?.data,
            });
            throw error;
        });
    },
    loadGtfsTable(payload) {
        const fd = new FormData();
        if (payload.file)
            fd.append("gtfs", payload.file);
        if (payload.cacheKey)
            fd.append("cache_key", payload.cacheKey);
        fd.append("table_name", payload.tableName);
        return api
            .post("/gtfs/tables/load", fd, {
            headers: { "Content-Type": "multipart/form-data" },
            // Eksik opsiyonel tablo (eski backend 400) gövdeyi okuyabilmek için
            validateStatus: (status) => (status >= 200 && status < 300) || status === 400,
        })
            .then((res) => {
            const data = res.data;
            if (res.status === 400 && data && typeof data === "object") {
                return data;
            }
            return data;
        });
    },
    modifyGtfs(payload) {
        const fd = new FormData();
        fd.append("gtfs", payload.gtfs);
        const modifications = payload.modifications ?? {};
        fd.append("modifications", JSON.stringify(modifications));
        return api
            .post("/gtfs/modify", fd, {
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((res) => res.data);
    },
    getRouteDetails(file, routeId) {
        const fd = new FormData();
        fd.append("gtfs", file);
        const routeIdString = String(routeId);
        return api
            .post(`/gtfs/route/${routeIdString}/details`, fd, {
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((res) => res.data);
    },
    getStopDetails(file, stopId) {
        const fd = new FormData();
        fd.append("gtfs", file);
        const stopIdString = String(stopId);
        return api
            .post(`/gtfs/stop/${stopIdString}/details`, fd, {
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((res) => res.data);
    },
    queryGtfsStops(payload) {
        const fd = new FormData();
        if (payload.file)
            fd.append("gtfs", payload.file);
        if (payload.cacheKey)
            fd.append("cache_key", payload.cacheKey);
        if (payload.q)
            fd.append("q", payload.q);
        if (payload.route_id)
            fd.append("route_id", payload.route_id);
        if (payload.wheelchair_boarding !== undefined && payload.wheelchair_boarding !== "") {
            fd.append("wheelchair_boarding", String(payload.wheelchair_boarding));
        }
        if (payload.location_type !== undefined && payload.location_type !== "") {
            fd.append("location_type", String(payload.location_type));
        }
        fd.append("limit", String(payload.limit ?? 200));
        fd.append("offset", String(payload.offset ?? 0));
        return api
            .post("/gtfs/stops/query", fd, {
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((res) => res.data);
    },
    queryGtfsTrips(payload) {
        const fd = new FormData();
        if (payload.file)
            fd.append("gtfs", payload.file);
        if (payload.cacheKey)
            fd.append("cache_key", payload.cacheKey);
        fd.append("route_id", String(payload.route_id));
        if (payload.service_id)
            fd.append("service_id", payload.service_id);
        if (payload.direction_id !== undefined && payload.direction_id !== "") {
            fd.append("direction_id", String(payload.direction_id));
        }
        fd.append("limit", String(payload.limit ?? 500));
        fd.append("offset", String(payload.offset ?? 0));
        return api
            .post("/gtfs/trips/query", fd, {
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((res) => res.data);
    },
    buildGtfsFromScenario(payload) {
        return api.post("/gtfs/build-from-scenario", payload).then((res) => res.data);
    },
    listGtfsFeeds(params) {
        return api.get("/gtfs/feeds", { params }).then((res) => res.data);
    },
    getGtfsFeed(feedId, includeZip = false) {
        return api
            .get(`/gtfs/feeds/${feedId}`, {
            params: { include_zip: includeZip ? 1 : 0 },
        })
            .then((res) => res.data);
    },
    saveGtfsFeed(payload) {
        return api.post("/gtfs/feeds", payload).then((res) => res.data);
    },
    deleteGtfsFeed(feedId) {
        return api.delete(`/gtfs/feeds/${feedId}`).then((res) => res.data);
    },
};
export default gtfsApi;
